import styled from '@emotion/styled';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';

import { theme } from '../../theme/theme';
import { SubmitFeedbackGlobalFeature } from './SubmitFeedbackGlobalFeature';

const ButtonPositioner = styled.div`
	position: fixed;
	inset-block-start: 50%;
	inset-inline-end: 0;
	z-index: ${theme.zIndex.feedbackButton};
	block-size: 0px;
	inline-size: 0px;
`;

const SubmitFeedbackContainer = styled(SubmitFeedbackGlobalFeature)`
	transform-origin: bottom right;
	transform: rotate(-90deg);
`;

const NoRoundedBottomButton = styled(Button)`
	border-end-start-radius: 0px;
	border-end-end-radius: 0px;
`;

export const SideContactUsButton = observer(function SideContactUsButton() {
	return (
		<ButtonPositioner>
			<SubmitFeedbackContainer>
				<NoRoundedBottomButton
					{...{
						type: 'primary',
						children: 'Contact us',
					}}
				/>
			</SubmitFeedbackContainer>
		</ButtonPositioner>
	);
});
